import { useEffect } from "react";
import styled from "styled-components";
import backToTopImage from "../../assets/images/back-to-top.png";

function BackToTopComponent(props) {
  useEffect(() => {
    window.onscroll = function () {
      const currentScrollPos = window.scrollY;
      let prevScrollPos = window.scrollY;
      if (prevScrollPos > currentScrollPos) {
        const backToTopButtonElement = document.querySelector("#back2Top");
        if (backToTopButtonElement) {
          backToTopButtonElement.classList.add("d-none");
        }
      } else {
        const backToTopButtonElement = document.querySelector("#back2Top");
        if (backToTopButtonElement) {
          backToTopButtonElement.classList.remove("d-none");
        }
      }
      if (currentScrollPos <= 150 || prevScrollPos <= 150) {
        const backToTopButtonElement = document.querySelector("#back2Top");
        if (backToTopButtonElement) {
          backToTopButtonElement.classList.add("d-none");
        }
      }
      prevScrollPos = currentScrollPos;
    };
  }, []);

  const BackToTopStyled = styled.div`
    position: fixed;
    bottom: 32px;
    right: 32px;
  `;

  return (
    <BackToTopStyled className="pointer d-none" id="back2Top">
      <img
        alt="#themeHeader"
        src={backToTopImage}
        onClick={(e) => {
          const element = document.getElementById("themeHeader");
          element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        }}
      />
    </BackToTopStyled>
  );
}

export default BackToTopComponent;
